import './manual-select-comp.css';

import * as React from 'react';
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { IBookSubscription } from 'app/shared/model/book-subscription.model';
import { ISport } from 'app/shared/model/sport.model';
import value from '*.json';
import { IBook } from 'app/shared/model/book.model';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

interface IManualSelectCompProps {
  firstName: string;
  lastName: string;
  bookSubscriptionList: ReadonlyArray<IBookSubscription>;
  sportList: ReadonlyArray<ISport>;
  selectedBookId: number;
  bookList: ReadonlyArray<IBook>;
  onReadMode: () => void;
}

interface IManualSelectCompState {
  dropdownOpen: boolean;
  index: number;
  reload: boolean;
}

export class ManualSelectComp extends React.Component<IManualSelectCompProps, IManualSelectCompState> {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      index: 0,
      reload: false
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  getSportsArray = sportsList => {
    const titleArray = new Array();
    sportsList.forEach((sport, sportIndex) => {
      titleArray.push(sport);
    });
    return titleArray;
  };

  getBookSubscriptionMap = (sportsList, bookSubscriptionList) => {
    const subscriptionMap = new Map();
    sportsList.forEach((sport, sportIndex) => {
      const sportName = sport.name;
      subscriptionMap.set(sportName, new Array());
    });

    bookSubscriptionList.forEach((bookSubscription, bookSubscriptionIndex) => {
      const sportName = bookSubscription.book.sport.name;
      if (subscriptionMap.has(sportName)) subscriptionMap.get(sportName).push(bookSubscription);
    });
    return subscriptionMap;
  };

  getBookById = (id, bookArray) => {
    let result = null;
    bookArray.forEach((item, index) => {
      if (item.id === parseInt(id, 10)) {
        result = bookArray[index];
      }
    });
    return result;
  };

  getBooksArray = booksList => {
    const bookArray = new Array();
    booksList.forEach((book, bookIndex) => {
      bookArray.push(book);
    });
    return bookArray;
  };

  reload = () => {
    this.setState({
      index: this.state.index + 1,
      reload: true
    });
  };

  renderReload = () => {
    if (this.state.reload) {
      return <Redirect to={`/home/${this.props.selectedBookId}/${this.state.index}`} />;
    }
  };

  render() {
    const { bookSubscriptionList, sportList, bookList } = this.props;
    const sportsArray = this.getSportsArray(sportList);
    const bookArray = this.getBooksArray(bookList);
    const bookSubscriptionMap = this.getBookSubscriptionMap(sportList, bookSubscriptionList);

    const currentBook = this.getBookById(this.props.selectedBookId, bookArray);

    // Books this user can open, grouped by sport: subscriptions plus free books
    const DropDownMenuItemArray = () => {
      const rowArray = [];

      sportsArray.forEach(sport => {
        const subscribedBooks = bookSubscriptionMap.get(sport.name).map(subscription => subscription.book);
        const subscribedIds = subscribedBooks.map(book => book.id);
        const freeBooks = bookArray.filter(
          book => book.sport.name === sport.name && book.isFree === true && subscribedIds.indexOf(book.id) === -1
        );
        const books = subscribedBooks.concat(freeBooks).sort((a, b) => a.name.localeCompare(b.name));

        if (books.length > 0) {
          rowArray.push(
            <DropdownItem key={`sport-${sport.id}`} header>
              {sport.name}
            </DropdownItem>
          );
          books.forEach(book => {
            rowArray.push(
              <DropdownItem
                key={`book-${book.id}`}
                active={currentBook !== null && book.id === currentBook.id}
                href={`/#/home/${book.id}/${this.state.index}`}
              >
                {book.name}
              </DropdownItem>
            );
          });
        }
      });
      return rowArray;
    };

    return (
      <div className="reader-bar">
        <Link to="/dashboard" className="reader-back">
          <FontAwesomeIcon icon="arrow-left" /> All books
        </Link>
        <div className="reader-title">
          <h1>{currentBook ? currentBook.name : ''}</h1>
          <span>{currentBook ? currentBook.sport.name : ''}</span>
        </div>
        <div className="reader-actions">
          {this.renderReload()}
          <Button onClick={this.props.onReadMode} color="link" className="reader-reload">
            <FontAwesomeIcon icon="eye" /> Read Mode
          </Button>
          <Button onClick={this.reload} color="link" className="reader-reload">
            <FontAwesomeIcon icon="sync" /> Reload
          </Button>
          <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
            <DropdownToggle caret className="reader-switch">
              Switch book
            </DropdownToggle>
            <DropdownMenu right className="reader-menu">
              {DropDownMenuItemArray()}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    );
  }
}

export default ManualSelectComp;
